
import { ICPServiceType1 } from "@/types/global";
import Link from "next/link";

interface Props {
    data: ICPServiceType1;
}

const ServiceAreaCard = ({ data }: Props) => {
    return (
        <>
            <div className="desilo-service-box5">
                <div className="h-100 d-flex flex-column">
                    <div className="h-100 d-flex flex-column justify-content-between">
                        <div >
                            <h4>
                                <Link href={data.link || '#'}>
                                    {data.title}
                                </Link>
                            </h4>
                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServiceAreaCard;
